import BaseMediaResource from './BaseMediaResource'

class VrArResource extends BaseMediaResource {
  get vrArUrl() {
    return this.resourceUrl
  }
}
export default VrArResource
